import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  used: number;
  max: number;
}

export default function SaturdaySlotCounter({ used, max }: Props) {
  const isAtLimit = used >= max;
  const isNearLimit = used === max - 1;

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-xs font-600 ${
        isAtLimit
          ? 'bg-red-50 border-red-200 text-danger'
          : isNearLimit
          ? 'bg-amber-50 border-amber-200 text-amber-700' :'bg-card border-border text-muted-foreground'
      }`}
    >
      {isAtLimit && <AlertTriangle size={13} />}
      <span>Saturday slots: {used}/{max}</span>
      {isAtLimit && <span className="text-danger">· ₱300 fee required</span>}
    </div>
  );
}